import { createVNode as a, mergeProps as i } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/SearchOutlined.js";
import c from "../components/PfIcon.js";
const r = (e, t) => {
  const o = {
    ...e,
    ...t.attrs
  };
  return a(c, i(o, {
    icon: n
  }), null);
};
r.displayName = "SearchOutlined";
r.inheritAttrs = !1;
export {
  r as default
};
